import {
    CidCvnDispatchContext,
    CidCvnStateContext,
    clearCidCvnErrors,
    clearSelectedReportHeader,
    setSelectedReportHeader,
    fetchCidCvnData,
    setCidCvnCheckBlock,
} from './cid-cvn.context';
import { useContext } from 'react';
import { CidCvnCheckResult } from '@packages/models/api';
import { CidCvnService } from './cid-cvn.service';

export const useCidCvnState = () => {
    const state = useContext(CidCvnStateContext);

    if (state === undefined) {
        throw new Error('useCidCvnState must be used within a CidCvnProvider');
    }
    return state;
};

export const useCidCvnDispatch = () => {
    const dispatch = useContext(CidCvnDispatchContext);

    if (dispatch === undefined) {
        throw new Error('useCidCvnDispatch must be used within a CidCvnProvider');
    }
    return dispatch;
};

export const useCidCvn = (cidCvnService: CidCvnService) => {
    const state = useCidCvnState();
    const dispatch = useCidCvnDispatch();

    return {
        ...state,
        clearErrors: () => clearCidCvnErrors(dispatch),
        clearSelectedReportHeader: () => clearSelectedReportHeader(dispatch),
        fetchCidCvnData: (vin: string, toggleLoading: boolean = true) => {
            if (!vin) {
                return;
            }
            return fetchCidCvnData(vin, toggleLoading, cidCvnService, dispatch, state.cidCvnEligible);
        },
        setCidCvnCheckBlock: (vin: string) => setCidCvnCheckBlock(vin, cidCvnService, dispatch),
        setSelectedReportHeader: (selectedReportHeader: {
            id: string | null;
            reportName: string | null;
            result: CidCvnCheckResult | null;
        }) => setSelectedReportHeader(dispatch, selectedReportHeader),
    };
};
